import { atom } from 'jotai';
import { $CurrentArticle } from '@article/shared/atoms/current-article';
import { $Locale } from '@lemon8/web-app-shared/atom';
import { ArticleDetailUtil } from 'shared/models';

export const $CurrentArticleTranslated = atom((get) => {
  const article = get($CurrentArticle);
  if (!ArticleDetailUtil.isArticleAvailable(article)) {
    return false;
  }

  const { region } = get($Locale);

  return ArticleDetailUtil.isTranslatedArticleToShow(article, region);
});
